import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from "@angular/core";
import { CanvasService } from "../canvas-service.interface";

/**
 * Generated class for the CanvasComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "mantis-canvas",
  templateUrl: "canvas.html",
})
export class CanvasComponent implements AfterViewInit {
  baseHeight = 100;
  baseWidth = 100;

  @ViewChild("canvas") canvasElement: ElementRef;
  @Input() canvasService: CanvasService;
  @Input() height = this.baseHeight;
  @Input() width = this.baseWidth;
  @Input() pointsMovable: boolean = true;

  canvas;
  backgrounds = {};
  points = [];
  bgImg = null;
  heightRatio = 1;
  widthRatio = 1;
  pointRadius = 20;
  subscriptions: Array<any> = [];
  drawDisabled: boolean = false;

  constructor() {}

  ngAfterViewInit() {
    // console.log( "View initialized!: ", this.canvasElement );

    let canvas = (this.canvas =
      this.canvasElement.nativeElement.getContext("2d"));
    let width = this.width;
    let height = this.height;

    this.heightRatio = height / this.baseHeight;
    this.widthRatio = width / this.baseWidth;

    canvas.font = "bold 18px Open Sans";
    canvas.textAlign = "center";
    canvas.textBaseline = "middle";

    // console.log( "Height ratio: ", this.heightRatio );
    // console.log( "Width ratio: ", this.widthRatio );

    this.subscriptions.push(
      this.canvasService.getBackgroundObservable().subscribe((url) => {
        // console.log( "Updating background: ", url );
        if (this.bgImg) {
          // console.log( "Old src: ", this.bgImg.src );
        }
        // canvas.clearRect(0, 0, width, height);

        if (!(this.bgImg && url == this.bgImg.src)) {
          this.bgImg = new Image();
          this.bgImg.onload = () => {
            this.drawBG();
            this.drawPoints();
          };
          this.bgImg.src = url;
        }
      })
    );

    this.subscriptions.push(
      this.canvasService.getAllPointDataObservable().subscribe((data) => {
        this.drawDisabled = false;
        //find active point
        for (let i = 0; i < data.points.length; i++) {
          let point = data.points[i];
          if (point["severity"] === 0 && point["active"]) {
            this.drawDisabled = true;
          }
        }

        this.drawBG();
      })
    );
    this.subscriptions.push(
      this.canvasService.getDrawPointsDataObservable().subscribe((data) => {
        if (!data || !data.points) {
          return;
        }

        this.points = data.points;
        // console.log(this.points);

        canvas.clearRect(0, 0, width, height);
        this.drawBG();
        this.drawPoints();
      })
    );
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  drawBG() {
    let bg = this.bgImg;
    let canvasElement = this.canvasElement.nativeElement;
    if (bg) {
      // console.log( "Drawing BG: ", bg );

      let imgWidth = bg.width;
      let imgHeight = bg.height;
      let canvasWidth = canvasElement.width;
      let canvasHeight = canvasElement.height;

      let imageAspectRatio = imgWidth / imgHeight;
      let canvasAspectRatio = canvasWidth / canvasHeight;

      let renderableHeight = canvasHeight;
      let renderableWidth = canvasWidth;
      let x = 0;
      let y = 0;

      if (imageAspectRatio < canvasAspectRatio) {
        renderableHeight = canvasHeight;
        renderableWidth = imgWidth * (renderableHeight / imgHeight);
        x = (canvasWidth - renderableWidth) / 2;
      } else if (imageAspectRatio > canvasAspectRatio) {
        renderableWidth = canvasWidth;
        renderableHeight = imgHeight * (renderableWidth / imgWidth);
        y = (canvasHeight - renderableHeight) / 2;
      }

      this.canvas.clearRect(0, 0, this.width, this.height);

      this.canvas.drawImage(
        this.bgImg,
        x,
        y,
        renderableWidth,
        renderableHeight
      );

      if (this.drawDisabled) {
        this.canvas.fillStyle = "rgba(155, 155, 155, 0.5)";
        this.canvas.fillRect(0, 0, this.width, this.height);
      }
    }
  }

  drawPoints() {
    let canvas = this.canvas;

    for (let i = 0; i < this.points.length; i++) {
      let data = this.points[i];

      if (!data["unspecifiedLocation"]) {
        if (data["active"]) {
          canvas.fillStyle = "rgba(174, 36, 101, 0.8)";
        } else {
          canvas.fillStyle = "rgba(155, 155, 155, 0.8)";
        }
        canvas.strokeStyle = "rgb(74, 74, 74)";
        canvas.lineWidth = 0.5;

        let x = this.widthRatio * data["x"];
        let y = this.heightRatio * data["y"];

        canvas.beginPath();
        canvas.arc(x, y, this.pointRadius, 0, 2 * Math.PI);
        canvas.fill();
        canvas.stroke();

        canvas.fillStyle = "white";
        canvas.fillText(data["index"] + 1, x, y);
      }
    }
  }

  canvasTouch(event) {
    let rawX = event.srcEvent.offsetX || event.srcEvent.layerX;
    let rawY = event.srcEvent.offsetY || event.srcEvent.layerY;

    // console.log( "EVENT: ", event );
    let x = rawX * (1 / this.widthRatio);
    let y = rawY * (1 / this.heightRatio);

    // console.log( "Clicked at: ", x, y );

    let clickedPoint = this.detectSelection(rawX, rawY);
    // console.log( "Clicked point: ", clickedPoint );

    if (clickedPoint) {
      this.canvasService.selectPoint(clickedPoint.index);
    } else {
      if (this.pointsMovable) {
        if (this.canvasService["dataSet"].length > 0) {
          if (this.canvasService["dataSet"][0].severity !== 0) {
            this.canvasService.updateActiveCoords(x, y);
          }
        }
      }
    }
  }

  detectSelection(x: number, y: number) {
    // console.log( "Looking for selection @", x, y );
    // console.log( "Radius: ", this.pointRadius );

    let radius = this.pointRadius;
    for (let i = 0; i < this.points.length; i++) {
      let point = this.points[i];
      // console.log( "Checking point: ", point );

      let rawX = point["x"] * this.widthRatio;
      let rawY = point["y"] * this.heightRatio;

      let dx = x - rawX;
      let dy = y - rawY;
      let collision = dx * dx + dy * dy <= radius * radius;

      // console.log( "DATA: ", dx, dy, collision );

      if (collision) {
        return point;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/canvas/canvas/canvas.ts